interface PreviewBannerProps {
  inPreview: boolean;
}

export default function PreviewBanner({ inPreview }: PreviewBannerProps) {
  return (
    inPreview && (
      <div className="mb-2 mt-2 bg-[#FFEE00] py-2 text-center font-bold text-black">
        Preview Mode
      </div>
    )
  );
}
